import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-agent-terms',
  templateUrl: './agent-terms.component.html',
  styleUrls: ['./agent-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentTermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
